/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ApplicationHealthBatchRequest {
    getFixupPrototypeFunction() { return ApplicationHealthBatchRequest.fixupPrototype; }

    static newInstance(model: Partial<ApplicationHealthBatchRequest>): ApplicationHealthBatchRequest {
        let obj = Object.assign(new ApplicationHealthBatchRequest(), model);
        ApplicationHealthBatchRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ApplicationHealthBatchRequest>): ApplicationHealthBatchRequest {
        if (!model) return null;
        return ApplicationHealthBatchRequest.newInstance(<ApplicationHealthBatchRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ApplicationHealthBatchRequest) {
        if (!obj) return;

        models.ApplicationHealthBatchRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ApplicationHealthBatchRequest): boolean {
        Object.setPrototypeOf(obj, ApplicationHealthBatchRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
    }

    /**
     * Identifiers to fetch
     */
    ids: Array<string>;

    /**
     * Start date for filtering alerts
     */
    start_date: Date;

    /**
     * End date for filtering alerts
     */
    end_date: Date;

}
